module.exports = __webpack_public_path__ + "static/media/eshlepIcon.80c87485.png";